// All 48 FIFA World Cup 2026 participants
// Maps Statscore team name variants → ISO 3166-1 alpha-2 codes for flagcdn.com
export const WC2026_FLAGS = {
  // AFC (9)
  "Australia": "au",
  "Iran": "ir", "IR Iran": "ir",
  "Iraq": "iq",
  "Japan": "jp",
  "Jordan": "jo",
  "Qatar": "qa",
  "Saudi Arabia": "sa",
  "South Korea": "kr", "Korea Republic": "kr",
  "Uzbekistan": "uz",

  // CAF (10)
  "Algeria": "dz",
  "Cape Verde": "cv", "Cabo Verde": "cv",
  "DR Congo": "cd", "Congo DR": "cd",
  "Egypt": "eg",
  "Ghana": "gh",
  "Ivory Coast": "ci", "Côte d'Ivoire": "ci", "Cote d'Ivoire": "ci",
  "Morocco": "ma",
  "Senegal": "sn",
  "South Africa": "za",
  "Tunisia": "tn",

  // CONCACAF (6)
  "Canada": "ca",
  "Curaçao": "cw", "Curacao": "cw",
  "Haiti": "ht",
  "Mexico": "mx",
  "Panama": "pa",
  "United States": "us", "USA": "us",

  // CONMEBOL (6)
  "Argentina": "ar",
  "Brazil": "br",
  "Colombia": "co",
  "Ecuador": "ec",
  "Paraguay": "py",
  "Uruguay": "uy",

  // OFC (1)
  "New Zealand": "nz",

  // UEFA (16)
  "Austria": "at",
  "Belgium": "be",
  "Bosnia and Herzegovina": "ba", "Bosnia-Herzegovina": "ba",
  "Croatia": "hr",
  "Czech Republic": "cz", "Czechia": "cz",
  "England": "gb-eng",
  "France": "fr",
  "Germany": "de",
  "Netherlands": "nl",
  "Norway": "no",
  "Portugal": "pt",
  "Scotland": "gb-sct",
  "Spain": "es",
  "Sweden": "se",
  "Switzerland": "ch",
  "Turkey": "tr", "Türkiye": "tr",
};

/**
 * Returns a flagcdn.com WebP URL for the given team name, or null if not found.
 * Size: w40 (~1-2 KB per flag, served from Cloudflare CDN)
 */
export const getFlagUrl = (name) => {
  if (!name) return null;
  const code = WC2026_FLAGS[name] || WC2026_FLAGS[name.trim()];
  return code ? `https://flagcdn.com/w40/${code}.webp` : null;
};
